module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAABY0lEQVR4Ab3BwWvNARwA8O97ZFrLYYc5iMhSKyUrf8BuUtzctqxYSE3JcdmXgxx24OYoh0VytYt2UHJ0Q1IylLQkJBvz0e/39t7vvd9yk88n/idNIw7pi3UueO2zRRMasZEBJ6V0NEqmVR4Zil62mZZSOhUlS7q9MhgVm01LKaXxiAhb1S1oRpsZd6SU0pEo+aDufLTot+yHq1JKo1HyQN1H/VEwqfDUZSltj5IxG41HwbyWh9KMZqyzoO5+FDzTds/p6DDopV5vo+Crym2N6DDsnW6/omBNt5sa0WGvJZWVKPii1/Xo4qw32t5HwaK6M9HhoiuWtSxGway6b4aiZEBK13xXmI2CnVbVzUXJPimlG/htJFrcUvc8SsaklNITC9Fmt096/bQlIsJxKaU0ZzgqDlvTbcWmiAhTUkrpQPQyZVXlbpRMSOmSg7GR/R5reWFHlOxxzgm74m+MmnRMX/w7fwCHUzttOvZQxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/home.png
// module id = 604
// module chunks = 0